import Button from "components/BaseWidgets/button";
import Filter from "components/Explore/components/Filter";

function LeftSection({ isLoading, onClick, isDisabled, searchType }) {
  return (
    <div className="left-section">
      <div className="flex flex-col gap-4 save-card">
        <p className="">Save this search</p>
        <Button
          isDisabled={isDisabled}
          isLoading={isLoading}
          onClick={onClick}
          height={30}
          className="save-btn"
          variant="primary"
        >
          Save
        </Button>
      </div>
      {searchType != 1 && <Filter className="search-filter" />}
    </div>
  );
}

export default LeftSection;
